import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxWarehousesDropdownMessagesScheme = z.object({
  warehouses_dropdown_change_warehouse:
    themeScheme.MessageScheme.default("Zmień hurtownię"),
  warehouses_dropdown_last_picked:
    themeScheme.MessageScheme.default("Ostatnio wybrane"),
  warehouses_dropdown_nearest_warehouses: themeScheme.MessageScheme.default(
    "Najbliższe hurtownie"
  ),
  warehouses_dropdown_pick_warehouse:
    themeScheme.MessageScheme.default("Wybierz hurtownię"),
  warehouses_dropdown_change: themeScheme.MessageScheme.default("Zmień"),
});

export const IBoxWarehousesDropdownSettingsScheme = z.object({
  warehouses_dropdown_pick_warehouse_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_pick_warehouse_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  warehouses_dropdown_last_picked_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_last_picked_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  warehouses_dropdown_nearest_warehouses_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_nearest_warehouses_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  warehouses_dropdown_warehouse_item_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_warehouse_item_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  warehouses_dropdown_change_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_change_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  warehouses_dropdown_change_warehouse_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  warehouses_dropdown_change_warehouse_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  popup_map_view: themeScheme.RowPopupScheme.default(""),
});
